function calculoImc(peso, altura) {
    const weigth = parseFloat(peso);
    const height = parseFloat(altura.replace(/,/g, '.'));

    const imc = (weigth / (height * height)).toFixed(2);

    return imc;
}

export { calculoImc };
